/// <amd-module name="Wit/WorkItemModel/Utils" />
import { IVssPageContext, TeamFoundationHostType } from "VSS/Platform/Context";
import { IVssLocationService } from "VSS/Platform/Location";
import { FutureDate } from "Wit/Common/WorkItemControls/Constants";
import * as Resources from "Wit/WorkItemModel/Resources";
import { IFilterXSSOptions, escapeAttrValue } from "xss";
import { superAllowList } from "xss/PresetOptions";

const controlChars = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/;
const surrogateChars = /(^[\uD800-\uDFFF]$)|[^\uD800-\uDBFF](?=[\uDC00-\uDFFF])|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/;

export const workItemLinkBeginningSign = "#";

export function getErrorMessage(errorString: string): string;
export function getErrorMessage(errorFunction: Function): string;
export function getErrorMessage(error: Error): string;
export function getErrorMessage(error: any): string {
    if (error) {
        if (typeof error === "string") {
            return error;
        } else if (typeof error === "function") {
            return getErrorMessage(error());
        } else if (error.message) {
            return error.message;
        } else if (error.description) {
            return error.description;
        } else {
            return error.toString();
        }
    } else {
        return Resources.UnknownError;
    }
}

export function parseNumber(value: string): number {
    value = value.trim();

    if (value.match(/^((0x[a-f0-9]+)|([0-9]+))$/i)) {
        return parseInt(value);
    }

    const floatRegex = /^(([+-]?\d*(\.\d*)?(e[+-]?\d+)?)|([+-]?infinity))$/i;

    if (value.match(floatRegex)) {
        return parseFloat(value);
    }

    return Number.NaN;
}

export function isRemoved(removedDate: Date | undefined): boolean {
    return !!removedDate && removedDate < FutureDate;
}

export function parseBool(value: string): boolean {
    /// <param name="value" type="string"></param>
    /// <returns type="Boolean"></returns>

    if (value) {
        let v = value.trim().toLowerCase();
        if (v === "true") {
            return true;
        }
    }

    return false;
}

export function containsControlChars(str: string): boolean {
    return controlChars.test(str);
}

export function containsMismatchedSurrogateChars(str: string): boolean {
    return surrogateChars.test(str);
}

export function isHtmlVisuallyBlank(htmlString: string) {
    const parse = Range.prototype.createContextualFragment.bind(document.createRange());
    const html = parse(htmlString);

    const allowedEmptyTags = ["EMBED", "IMG", "INPUT", "PICTURE", "VIDEO"];
    const children = html.children;

    if (children.length > 0) {
        for (let i = 0; i < children.length; i++) {
            if (allowedEmptyTags.includes(children[i].tagName)) {
                return false;
            }
        }
    }

    return (html.textContent ?? "").trim() === "";
}

export async function getWorkItemUrl(pageContext: IVssPageContext, projectId: string, workItemId: number): Promise<string> {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");
    const rootUrl = await locationService.getServiceLocationAsync(undefined, TeamFoundationHostType.ProjectCollection);

    return `${rootUrl}${projectId}/_apis/wit/workItems/${workItemId}`;
}

export const htmlSanitizerPreserveClassAndMentionOptions: IFilterXSSOptions = {
    ...superAllowList,
    onTag: function (tag, html, options) {
        if (tag.match(/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}/g)) {
            return html;
        }
    },
    onIgnoreTagAttr: function (tag, name, value) {
        if (name.substring(0, 5) === 'class' || name.substring(0, 15) === "data-vss-mention") {
            return `name="${escapeAttrValue(value)}"`;
        }
    }
};

export function getEndingNumberFromUrl(url: string): number | undefined {
    if (url) {
        url = url.trim();
        const matches = url.match(/\/(\d+)\/$/);
        if (matches) {
            const workItemIdString = matches?.[1];
            const workItemId = parseInt(workItemIdString);
            if (!isNaN(workItemId)) {
                return workItemId;
            }
        }
    }
}
